module.exports = __webpack_public_path__ + "img/podcast-no-image.3bc48ca8.png";